var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.902 27.201-2.247-25.201h24.69l-2.25 25.197-10.11 2.803z",
    fill: "#e44f26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 27.858 8.17-2.265 1.922-21.532h-10.092z",
    fill: "#f1662a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16 13.407h-4.09l-.282-3.165h4.372v-3.091h-.011-7.739l.074.83.759 8.517h6.917z",
    fill: "#ebebeb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16 21.434-.014.004-3.442-.929-.22-2.465h-1.673-1.43l.433 4.852 6.332 1.758.014-.004z",
    fill: "#ebebeb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.989 13.407v3.091h3.806l-.358 4.009-3.448.93v3.216l6.337-1.757.046-.522.726-8.137.076-.83h-.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.989 7.151v1.92 1.164.007h7.456.01l.062-.694.141-1.567.074-.83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeHtml);
export default __webpack_public_path__ + "static/media/file-type-html.51305ec564cee03372ec0fdaaa77854d.svg";
export { ForwardRef as ReactComponent };